module.exports = __webpack_public_path__ + "static/img/feature_1.e0847c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_educloud/feature_1.png
// module id = mQMi
// module chunks = 0